import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

/* Route `handle.crumbs` is static; a screen that knows a name only after its query
   resolves publishes the full trail here and Topbar prefers it. */

type CrumbsContextValue = { crumbs: string[] | null; setCrumbs(next: string[] | null): void };

const CrumbsContext = createContext<CrumbsContextValue>({ crumbs: null, setCrumbs: () => {} });

export function CrumbsProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbs] = useState<string[] | null>(null);
  return <CrumbsContext.Provider value={{ crumbs, setCrumbs }}>{children}</CrumbsContext.Provider>;
}

export function useDynamicCrumbs(): string[] | null {
  return useContext(CrumbsContext).crumbs;
}

export function usePublishCrumbs(crumbs: string[] | null): void {
  const { setCrumbs } = useContext(CrumbsContext);
  // Serialised so the effect keys on the crumb values, not on a fresh array each render.
  const trail = crumbs === null ? null : JSON.stringify(crumbs);
  useEffect(() => {
    setCrumbs(trail === null ? null : (JSON.parse(trail) as string[]));
    return () => setCrumbs(null);
  }, [setCrumbs, trail]);
}
